import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import NavigationHeader from "@/components/ui/navigation-header";
import {
  Calculator,
  User,
} from "lucide-react";
// import { useAuth } from "@/hooks/useAuth";

import CashClosingModal from "@/components/business/pos/CashClosingModal";
import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";

/**
 * Layout específico para la sección POS
 *
 * Diseñado para la interfaz de punto de venta con
 * navegación mínima y enfoque en la funcionalidad POS.
 * Optimizado para pantallas táctiles y tablets.
 */
const POSLayout: React.FC = () => {
  // const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [isCashClosingModalOpen, setIsCashClosingModalOpen] = useState(false);
  // const [isOrderQueueOpen, setIsOrderQueueOpen] = useState(false);

  const navigationItems = [
    {
      name: "POS",
      href: "/pos",
      icon: Calculator,
      description: "Punto de venta",
      highlight: true,
    },
    {
      name: "Perfil",
      href: "/profile",
      icon: User,
      description: "Configuración personal",
    },
  ];

  // Logo personalizado para POS
  const posLogo = (
    <div className="flex items-center space-x-2">
      <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center shadow-sm">
        <Calculator className="h-6 w-6 text-primary-foreground" />
      </div>
      <div>
        <h1 className="text-lg md:text-xl font-bold text-card-foreground">
          Rincón Chilenito
        </h1>
        <p className="text-xs text-muted-foreground hidden sm:block text-left">
          Punto de Venta
        </p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-background">
      {/* Header Unificado */}
      <NavigationHeader
        variant="cajero"
        title="Rincón Chilenito"
        subtitle="Punto de Venta"
        logo={posLogo}
        showCart={false}
        showThemeToggle={false}
        showUserMenu={true}
        userMenuVariant="compact"
      />

      {/* Navegación simplificada */}
      <nav className="border-b bg-muted/30">
        <div className="container mx-auto px-4">
          <div className="flex items-center gap-1 py-2">
            {navigationItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.href;

              return (
                <Button
                  key={item.name}
                  variant={isActive ? "default" : "ghost"}
                  size="sm"
                  onClick={() => navigate(item.href)}
                  className={cn(
                    "flex items-center gap-2 transition-colors",
                    isActive &&
                      item.highlight &&
                      "bg-primary text-primary-foreground shadow-sm"
                  )}
                >
                  <Icon className="h-4 w-4" />
                  <span className="hidden sm:inline">{item.name}</span>
                  {item.highlight && (
                    <Badge variant="secondary" className="ml-1 text-xs">
                      POS
                    </Badge>
                  )}
                </Button>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Contenido principal */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Modales */}
      <CashClosingModal
        isOpen={isCashClosingModalOpen}
        onClose={() => setIsCashClosingModalOpen(false)}
        onLogout={() => {}}
      />
      {/* <OrderQueue
        // isOpen={isOrderQueueOpen}
        // onClose={() => setIsOrderQueueOpen(false)}
      /> */}
    </div>
  );
};

export default POSLayout;
